import * as React from 'react';
import { useState, useMemo } from 'react';
import { Media, Image } from '../types/Media';
import { Lightbox } from './Lightbox';

interface ImageProps {
    url: string;
    width: number;
    height: number;
    media: Media[];
}

export const Gallery: React.FC<ImageProps> = ({ url, width, height, media }) => {
    const [open, setOpen] = useState(false);
    const images = useMemo(() => {
        return media.filter((item): item is Image => item.type === 'image');
    }, media);

    const handleImageClick = (e: React.MouseEvent) => {
        e.preventDefault();

        setOpen(true);
    };

    return (
        <>
            <a href="#view-images" onClick={handleImageClick} className="gallery">
                <img
                    src={url}
                    style={{ height, width }}
                />

                <div className="toolbar">
                    <p>Image 1 of {images.length}</p>
                    <p>Click to expand</p>
                </div>
            </a>

            <Lightbox
                images={images}
                shown={open}
                setShown={setOpen}
            />
        </>
    );
};

Gallery.displayName = 'Gallery';
